import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { PhoneCountryCodeType } from '@bus/models';
import { getEnumValues } from '../../../../../services/common/miscUtils';
import { allNaceCodes, allNaceSections } from '../../../../../services/common/naceCodes';
import Yup, {
  maxMobileNumberLength,
  minMobileNumberLength,
  regExEmail,
  regexVat,
} from '../../../../../services/common/validation';
import { CompanyClassificationEnum, NoYesEnum } from '../../../../../types/forms';
import { CompanyDetailsFormModel_OB_OL } from './formModel';

export const getValidationSchema = (isCroRequired = true): ObjectSchema<Partial<CompanyDetailsFormModel_OB_OL>> => {
  const croNumberMaxLength = 6;

  const croRequiredSchema = Yup.string()
    .requiredWithMsg()
    .onlyNumbers()
    .max(croNumberMaxLength, t('validation:maxLength', { value: croNumberMaxLength }));

  const croOptionalSchema = Yup.string()
    .optional()
    .onlyNumbers()
    .max(croNumberMaxLength, t('validation:maxLength', { value: croNumberMaxLength }));

  const croNumber = isCroRequired ? croRequiredSchema : croOptionalSchema;

  return Yup.object({
    tradingName: Yup.string().requiredWithMsg(),
    legalName: Yup.string().requiredWithMsg(),
    vatLiable: Yup.string().requiredWithMsg().oneOf(getEnumValues(NoYesEnum)),
    vatNumber: Yup.string().when('vatLiable', {
      is: (vatLiable: NoYesEnum) => vatLiable === NoYesEnum.yes,
      then: (schema) =>
        schema
          .matches(regexVat, { message: t('validation:invalidVat') })
          .lengthBetween(0, 10)
          .requiredWithMsg(),
      otherwise: (schema) =>
        schema
          .optional()
          .matches(regexVat, { message: t('validation:invalidVat') })
          .lengthBetween(0, 10),
    }),
    croNumber,
    dateOfIncorporation: Yup.string().requiredWithMsg(),
    businessType: Yup.string().requiredWithMsg().oneOf(allNaceSections),
    businessSubType: Yup.string().requiredWithMsg().oneOf(allNaceCodes),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(PhoneCountryCodeType)),
    phoneNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    email: Yup.string().requiredWithMsg().matches(regExEmail, t('validation:invalidEmail')),
    fleetSize: Yup.number().typeError(t('validation:required')).requiredWithMsg(),
    companyClassification: Yup.string().requiredWithMsg().oneOf(getEnumValues(CompanyClassificationEnum)),
    turnover: Yup.number().typeError(t('validation:required')).requiredWithMsg(),
  });
};
